import { rootUrl } from "../helpers";
import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

import LoginSignupModal from "../components/loginModal";
const AuthContext = createContext({ user: null, login: null, logOut: null });

export function AuthProvider({ children }) {
  const clearSession = () => {
    localStorage.clear();
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["X-Auth-Token"];
  };

  const getUser = () => {
    const personId = localStorage.getItem("userId")
    try {
      const userData = JSON.parse(localStorage.getItem(personId))
      return userData
    } catch (error) {
      return null
    }
  };
  const savedToken = localStorage.getItem("apiToken");
  if (savedToken) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;
    axios.defaults.headers.common["X-Auth-Token"] = savedToken;
  }
  const [user, setUser] = useState(getUser);

  useEffect(() => {
    const requestInterceptorId = axios.interceptors.request.use((config) => {
      const token = localStorage.getItem("apiToken");
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["X-Auth-Token"] = token;
      }
      return config;
    });

    let hasHandledUnauthorized = false;
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        if (status === 401 && !hasHandledUnauthorized) {
          hasHandledUnauthorized = true;
          clearSession();
          setUser(null);
          toast.error("Session expired. Please login again.");
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptorId);
      axios.interceptors.response.eject(interceptorId);
    };
  }, []);

  let login = async (values, callback) => {
    try {
      const response = await axios.post(rootUrl("/login"), values)
      if(response.data.status == 200){
        const authData = response.data.data || {};
        const fetchedUser = authData.user || authData;
        const token = authData.token || "";
        const userId = fetchedUser?.id || fetchedUser?.userId;
        if (userId) {
          localStorage.setItem("userId", userId);
          localStorage.setItem(String(userId), JSON.stringify(fetchedUser));
        }
        if (token) {
          localStorage.setItem("apiToken", token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          axios.defaults.headers.common["X-Auth-Token"] = token;
        }
          setUser(fetchedUser)
          toast.success("Login Successful")
          callback()
    }else{
      toast.error(response.data.message)
    }
    } catch (error) {
      toast.error("An error occured while logging in")
      // toast.error(error?.message)
    }
  };

  let logOut = (callback) => {
    clearSession();
    callback()
  };

  let value = { user, login, logOut }
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function RequireAuth({ children }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpened, setIsModalOpened] = useState(false); 
    const handleOpenModal = () => {
      if (!isModalOpened) { 
        setIsModalOpen(true);
        setIsModalOpened(true); 
      }
    };
    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
    const auth = useAuth();
    if (!auth || !auth.user) {
      handleOpenModal();
    }
    return (
      <>
        {isModalOpen && (
          <LoginSignupModal open={isModalOpen} handleClose={handleCloseModal} />
        )}
        {children}
      </>
    );
  }

  export function useAuth() {
    const auth = useContext(AuthContext);
    if (!auth) {
      throw new Error("Auth context is null");
    }
    return auth;
  }
